import React, {Component} from 'react';
import AUX from '../../hoc/Aux_';
import Button from '@material-ui/core/Button';
import ButtonGroup from '@material-ui/core/ButtonGroup';
import FormControl from '@material-ui/core/FormControl';
import {postDictionary, putDictionary } from '../../api/dictionary';
import Grid from '@material-ui/core/Grid';
import { InputLabel, Input, FormHelperText } from '@material-ui/core';

import { css } from "@emotion/core";
import {BarLoader} from "react-spinners";

const override = css`
position: absolute;
  top: 50%;
  left: 40%;
  margin: 0 auto;
`;

class AddDictionary extends Component{

  constructor(props) {
    super(props);
    this.state = {
      word : "",
      wordTarget: "",
      dictionaryId:"",
      dataUpdate : this.props.data,
      action: "add",
      loading: false
    }
  }

  componentWillMount(){

    console.log(this.state.dataUpdate);
    if(this.state.dataUpdate.length>0){
      console.log(this.state.dataUpdate[2]);
      this.setState({
        dictionaryId: this.state.dataUpdate[3],
        word : this.state.dataUpdate[1],
        wordTarget: this.state.dataUpdate[2],
        action: "update"
      })
    }else{

    }
  }

  handleChangeText = (keys,e) => {
      this.setState({ [keys]: e.target.value });
  };

  submitForm = () => {
    this.setState({loading:true});
    if(this.state.action == "add"){
    postDictionary(this.state)
      .then(response => {
        //this.props.pushCategory(response.data);
        this.props.handleOpen(false);
        this.props.handleReload(true);
        this.setState({loading:false});
      })
      .catch(error => {
        console.log(error);
      });
    }else{
      putDictionary(this.state)
        .then(response => {
          //this.props.pushCategory(response.data);
          this.props.handleOpen(false);
          this.props.handleReload(true);
          this.setState({loading:false});
        })
        .catch(error => {
          console.log(error);
        });
    }


  }

  render(){
    return (
      <Grid item xs={12}  >
      <div className="sweet-loading">
        <BarLoader
          css={override}
          height={4}
          width={300}
          color={"#C51162"}
          loading={this.state.loading}
        />
      </div>
      <Grid item xs={6}>
        <FormControl>
          <InputLabel htmlFor="word">Word</InputLabel>
          <Input id="word" aria-describedby="word"
            value = {this.state.word}
            onChange = {(e) => this.handleChangeText("word",e)}
          />
        </FormControl>{' '}
        <FormControl>
          <InputLabel htmlFor="wordTarget">Word Target</InputLabel>
          <Input id="wordTarget" aria-describedby="wordTarget"
            value = {this.state.wordTarget}
            onChange = {(e) => this.handleChangeText("wordTarget",e)}
          />
        </FormControl>{' '}

      </Grid>
      <Grid item xs={6}>
      <br/>
        <Button variant="contained" color="primary" onClick = {this.submitForm}>Save</Button>

      </Grid>
      </Grid>
    )
  }
}

export default AddDictionary;
